<div class="addList">
  <div class="addListItem">
    <h4>1. Download the template</h4>
    <span class="download-file">
      <i class="fal fa-file-csv"></i>
      <a href="assets/files/StaffUploadTemplate.csv" automation-id="add-staff-wrapper-upload-template" download>
        <label>Staff Upload Template CSV Spreadsheet</label>
      </a>
    </span>
  </div>
  
  <div class="addListItem">
    <h4>2. Fill in the template</h4>
    <i>
      Keeping the column headings as is!
      <span >
        <img src="assets/images/gcsv_graphic.png" />
      </span>
    </i>
  </div>

  <div class="addListItem">
    <h4>3. Upload your completed spreadsheet here!</h4>
    <i>Browse or drag & drop the file in the target</i>
    <app-csv-file-upload (file)="acceptFile($event)" (fileName)="setFileName($event)"></app-csv-file-upload>
  </div>
</div>
